import { Button, Drawer } from '@crosscode/gravity-components'
import { CameraOutlined } from '@ant-design/icons'
import { PriceCheckerActions } from './DeviceActions'
import type { PriceChecker } from './utils'
import styles from '@/pages/HomePage.module.css'

interface Props {
  open: boolean
  checker: PriceChecker | null
  statusLabel?: string
  onClose: () => void
}

export function PriceCheckerDetailsDrawer({ open, checker, statusLabel, onClose }: Props) {
  if (!checker) {
    return <Drawer title="Прайс-чекер" open={open} onClose={onClose} size={480} />
  }

  const title = checker.name || `Прайс-чекер ${checker.id}`
  const offline = statusLabel ? /оффлайн/i.test(statusLabel) : checker.online === false
  const isOn = Boolean(statusLabel && /онлайн/i.test(statusLabel))
  const ping = statusLabel?.match(/\d+(\.\d+)?ms/i)?.[0] ?? null
  const statusText = offline ? 'Оффлайн' : isOn ? 'Онлайн' : 'Проверка…'

  return (
    <Drawer title={title} open={open} onClose={onClose} size={480}>
      <div className={styles.drawerHero}>
        <span className={styles.drawerIcon}>
          <CameraOutlined />
        </span>
        <div className={styles.drawerHeroText}>
          <div className={styles.drawerType}>Прайс-чекер</div>
          <span
            className={[
              styles.statusCell,
              isOn ? styles.statusOn : '',
              offline ? styles.statusOff : '',
              !isOn && !offline ? styles.statusMuted : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <i className={styles.statusDot} aria-hidden />
            {statusText}
            {ping ? <span className={styles.statusPing}> · {ping}</span> : null}
          </span>
        </div>
      </div>

      <div className={styles.drawerMeta}>
        <div className={styles.metaRow}>
          <span className={styles.metaKey}>IP</span>
          <span className={styles.metaVal}>
            <span className={styles.mono}>{checker.ip || '—'}</span>
          </span>
        </div>
        <div className={styles.metaRow}>
          <span className={styles.metaKey}>ID</span>
          <span className={styles.metaVal}>{String(checker.id)}</span>
        </div>
      </div>

      <div className={styles.drawerActions}>
        <PriceCheckerActions checkerId={checker.id} />
        <Button onClick={onClose}>Закрыть</Button>
      </div>
    </Drawer>
  )
}
